import React from "react";
import { TextField, MenuItem, FormControl, FormLabel } from "@mui/material";

const PlanSubscriptionSelectInput = ({
  id,
  label,
  name,
  value = "",
  onChange,
  required,
  helperText,
  options = [],
  disabled = false,
}) => {
  return (
    <FormControl
      fullWidth
      required={required}
      sx={{ mb: 2 }}
      disabled={disabled}
    >
      <FormLabel htmlFor={id}>{label}</FormLabel>
      <TextField
        id={id}
        name={name}
        select
        value={value}
        onChange={onChange}
        helperText={helperText}
        disabled={disabled}
      >
        {options.map((opt, index) => (
          <MenuItem key={index} value={opt.id}>
            {`${opt.label} (${opt.value})`}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
};

export default PlanSubscriptionSelectInput;
